exports.severities = {
  severe: {
    code: '24484000',
    display: 'Severe',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  moderate: {
    code: '6736007',
    display: 'Moderate',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
  mild: {
    code: '255604002',
    display: 'Mild',
    system: 'http://snomed.info/sct',
    version: '1.0.0',
  },
};
exports.burnSeverities = {
  burnSuperficial: {
    code: 'burnSuperficial',
    display: 'Superficial (1st Degree)',
    system: 'bcm',
    version: '1.0.0',
  },
  burnPartialThickness: {
    code: 'burnPartialThickness',
    display: 'Partial Thickness (2nd Degree)',
    system: 'bcm',
    version: '1.0.0',
  },
  burnDeepPartialThickness: {
    code: 'burnDeepPartialThickness',
    display: 'Deep Partial Thickness (2nd Degree)',
    system: 'bcm',
    version: '1.0.0',
  },
  burnFullThickness: {
    code: 'burnFullThickness',
    display: 'Full Thickness (3rd Degree)',
    system: 'bcm',
    version: '1.0.0',
  },
};